angular.module('iqxCore')
.controller('actionDialogViewEventLogCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, $sce) {
  $scope.ContactEventDetails = undefined
  $scope.showAll=false

	$scope.filters = {}
	$scope.OrderBy = "ContactEventTime desc"
	$scope.daterangeSet=false
	$scope.filters.TimeStart = moment().subtract(6, 'month').toDate()
	$scope.filters.TimeEnd = moment().toDate()
	$scope.daterangeSet=true
	$scope.filters.ClassType = ""
	$scope.filters.Description = ""
	$scope.filters.Outcome = ""
	$scope.filters.StaffName = ""

 	$scope.setDateRange=function(){
 		var data={
 			xTimeStart: $scope.filters.TimeStart,
 			xTimeEnd: $scope.filters.TimeEnd
 		}
 		FormSvc.modalForm($scope,'setDateRange',data,'md',{label:'col-sm-3', data:'col-sm-7'})
 		.then(function(data){

 			$scope.filters.TimeStart=data.xTimeStart
 			$scope.filters.TimeEnd=data.xTimeEnd
 			$scope.daterangeSet=true
 			$scope.updateResults()
 		})
 	}

	$scope.setSettings=function(){
		var data={
 			xTimeStart: $scope.filters.TimeStart,
 			xTimeEnd: $scope.filters.TimeEnd,
			xClassType: $scope.filters.ClassType,
			xDescription: $scope.filters.Description,
			xOutcome: $scope.filters.Outcome,
			xStaffName: $scope.filters.StaffName,
      xOrderBy: $scope.OrderBy,
      xShowAll: $scope.showAll
		}
		FormSvc.modalForm($scope,'setSettings',data,'lg',{label:'col-sm-3', data:'col-sm-7'})
		.then(function(data){
			$scope.filters.TimeStart=data.xTimeStart
			$scope.filters.TimeEnd=data.xTimeEnd
			$scope.filters.ClassType=data.xClassType
			$scope.filters.Description=data.xDescription
			$scope.filters.Outcome=data.xOutcome
			$scope.filters.StaffName=data.xStaffName
      $scope.showAll=data.xShowAll
			$scope.OrderBy=data.xOrderBy
			$scope.daterangeSet=true
			$scope.updateResults()
		})
	}

 	$scope.updateOrderBy = function(colName){
 		var stringLength = colName.length
 		if($scope.OrderBy.substring(0, stringLength) == colName){
 			if($scope.OrderBy == colName + " asc"){
 				$scope.OrderBy = colName + " desc"
 			} else if ($scope.OrderBy == colName + " desc"){
 				$scope.OrderBy = colName + " asc"
 			}
 		}else{
 			$scope.OrderBy = colName + " asc"
 		}
 		$scope.updateResults()
 	}

  switch($scope.actiondialogparams.type.toLowerCase()) {
    case 'person':
      $scope.typeID = "pPersonID"
    break

    case 'staff':
      $scope.typeID = "pStaffID"
    break

    case 'contact':
      $scope.typeID = "pEmploymentID"
    break

    case 'vacancy':
      $scope.typeID = "pVacancyID"
    break

    case 'company':
      $scope.typeID = "pCompanyID"
    break

    default:
      $scope.typeID="NONE"
    break
  }

  $scope.goBack=function(){
    $scope.ContactEventDetails = undefined
  }

  $scope.humanifyString=function(string){
    return string
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function(str){ return str.toUpperCase(); })
  }

  $scope.contactEventMoreInfo=function(ContactEvent){
    delete ContactEvent['$$hashKey']
    delete ContactEvent['ContactEventID']
    delete ContactEvent['Priority']
    $scope.ContactEventDetails = ContactEvent
    angular.forEach(ContactEvent, function(event, key){ // Trust our output
      $scope.ContactEventDetails[key] = $sce.trustAsHtml(ContactEvent[key])
    })
  }

	$scope.updateResults = function(){
		var fetchApiString = "callresult/NetOwnerContactEvents?"
      +
      $scope.typeID
      +
      '='
      +
      $scope.actiondialogparams.linkID
      +
      ($scope.showAll ? '&pAllEvents=1' : '' )

		fetchApiString = fetchApiString + '&pOrderBy='+$scope.OrderBy

		angular.forEach($scope.filters, function(value, key) {
  		if (value && value != ""){
				if(key!='TimeStart' && key!='TimeEnd'){
					fetchApiString = fetchApiString + "&pFilter"+key+"="+"%"+value+"%"
				}else{
					fetchApiString = fetchApiString + "&pFilter"+key+"="+moment(value).toISOString()
				}
			}
		})

		FormSvc.setOptions($scope,{
			fetchAPI: fetchApiString,
			multiRow:true,
      sliceSize:500, // number of items per fetch
      numPerPage:10, // number of items per page - needs to be 1/2 or less of sliceSize.
			lazyPage:true, // use new paging mechagnism - will create scope var for setting num per page which can be updated after calling setOptions, default is 10
      dateFields:['ContactEventTime']
		})

		$scope.lazyPage.refreshResults = true // VERY IMPORTANT - if you dont do this when changing filters you will still get the old results!
		$scope.fetch()
	}

	$scope.updateResults()

})
